export default class PhoneNumberValidation{
	static get REG_EXP_INTERNATIONAL_NUMBER(){
		return new RegExp('^(?:(?:\\+[1-9]{1}[0-9]{3,14})|(?:[0-9]{4,15}))$');
	}
	static validateInternational(value){
		return PhoneNumberValidation.REG_EXP_INTERNATIONAL_NUMBER.test(value);
	}
}